<template>
    <div class="chapter-item" :class="{editing:edit}">
        <div class="line" @dblclick.stop="$emit('edit')" @click="$emit('select')">
            <div class="left">
                <div class="image">
                    <img :src="chapter.getBaseImage()" v-if="chapter.getBaseImage() !== ''">
                </div>
                <div class="texts">
                    <div class="title-h2">
                        {{ $t('Chapter') }} {{ chapter.order + 1 }}
                    </div>
                    <div class="title-h1" v-if="!edit && showTitle">
                        {{ chapter.title | subStr}}
                    </div>
                </div>
            </div>
            <div class="buttons pr-1">
                <div class="weight" v-if="chapter.base_image.size !== 0">
                    {{ baseImageSize }}
                </div>
                <div class="btn square item grip">
                    <tooltip delay="0.5s" :text="$t('Grip')">
                        <i class="fal fa-grip-horizontal"></i>
                    </tooltip>
                </div>
                <btn square item remove @click="remove" v-if="!chapter.isNew() && chapterCount > 1">
                    <tooltip :text="$t('Delete chapter')" delay="0.5s" position="left">
                        <i class="fal fa-trash"></i>
                    </tooltip>
                </btn>
                <btn link item remove @click="cancel" v-if="edit && chapter.isNew()">
                    <tooltip :text="$t('Cancel changes')" delay="0.5s" position="left">
                        Cancel
                    </tooltip>
                </btn>
                <btn square item @click="save" v-if="edit && chapter.isNew()" color="save">
                    <tooltip :text="$t('Save changes')" delay="0.5s" position="left">
                        <i class="fal fa-save"></i>
                    </tooltip>
                </btn>
                <btn square item @click="save" v-if="edit && !chapter.isNew()" :color="hasChange ? 'save' : ''">
                    <tooltip :text="$t('Close')" delay="0.5s" position="left">
                        <i class="fal fa-times" v-if="!hasChange"></i>
                        <i class="fal fa-save" v-else></i>
                    </tooltip>
                </btn>
                <btn square item @click="$emit('edit')" v-if="!edit">
                    <tooltip :text="$t('Edit chapter')" delay="0.5s" position="left">
                        <i class="fal fa-edit"></i>
                    </tooltip>
                </btn>
            </div>
        </div>
        <div class="label-edition" @dblclick.stop>
            <div class="form" v-show="edit">
                <input-text v-model="chapter.title" :label="$t('Title')" ref="input" @change="autoSave()" :disabled="!showTitle"/>
                <input-textarea v-model="chapter.teaser" :label="$t('Teaser')" @change="autoSave()"/>
                <input-media v-model="chapter.base_image" :label="$t('Image')" :storie-id="chapter.getStoryId()" @change="autoSave(); reloadStoryContent()"/>
            </div>
        </div>
    </div>
</template>

<script>
import chapterClass from "@/class/interactive-image/chapter";
import Btn from "@/modules/buttons/btn";
import InputText from "@/modules/input/input-text";
import InputMedia from "@/modules/input/input-media";
import InputTextarea from "@/modules/input/input-textarea";
import tools from "@/class/tools";
import Tooltip from "@/modules/tooltip";
import {saveContentOnglet} from "@/class/onglets/onglet";

export default {
    name: "InteractiveImage_Chapter",
    components: {Tooltip, InputTextarea, InputMedia, InputText, Btn},
    props: {
        chapter: {type: Object, default: () => new chapterClass()},
        edit:Boolean,
        chapterCount:Number,
        showTitle:Boolean,
    },
    data() {
        return {
            old:"",
            inSave:false,
            hasChange:false,
        }
    },
    methods: {
        async save(){
            if(this.chapter.title === ""){
                this.chapter.title = "Chapter "+(this.chapter.order+1)
            }
            
            // if(this.chapter.base_image.media === "" && this.chapter.isNew()){
            //     return this.$vs.dialog({
            //         type: 'alert',
            //         color: 'danger',
            //         title: this.$t('Error'),
            //         text: this.$t("The field "+this.$t("Base Image")+" is required"),
            //     })
            // }
            // if(this.chapter.base_image.id ===  "" && this.chapter.isNew()){
            //     return this.$vs.dialog({
            //         type: 'alert',
            //         color: 'danger',
            //         title: this.$t('Error'),
            //         text: this.$t("Wait the end of the upload"),
            //     })
            // }
            
            this.hasChange = false
            this.inSave = true
            this.chapter.unedit()
            await this.chapter.save(false);
            this.inSave = false
        },
        autoSave(){
            if(this.chapter.isNew()) return;
            
            this.chapter.save(false)
        },
        cancel(){
            if(this.old === JSON.stringify(this.chapter.getDataReq())){
                if(this.chapter.isNew()){
                    this.removeConfirm();
                }
                return this.chapter.unedit()
            }
            return this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('Confirm'),
                text: this.$t("Do you really want to cancel the changes ?"),
                acceptText:this.$t('Yes, cancel the changes'),
                cancelText:this.$t('No'),
                accept: this.cancelConfirm
            })
        },
        cancelConfirm(){
            if(this.chapter.isNew()){
                return this.removeConfirm();
            }
            
            this.chapter.setDataOnly(JSON.parse(this.old));
            this.chapter.unedit()
        },
        remove() {
            return this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('Confirm'),
                text: this.$t("Do you really want to remove the chapter ?"),
                acceptText:this.$t('Yes, remove it'),
                cancelText:this.$t('No'),
                accept: this.removeConfirm
            })
        },
        removeConfirm() {
            this.$emit("remove",this.chapter);
        },
        async focus(){
            await this.$nextTick();
            if(this.$refs.input) {
                this.$refs.input.focusInput()
            }
        },
        reloadStoryContent(){
            const story = saveContentOnglet.objectGet("story",this.chapter.getStoryId())
            story.loadContent()
        }
    },
    computed:{
        baseImageSize(){
            return tools.sizeToString(this.chapter.base_image.size)
        },
        change(){
            return this.chapter.getDataReq()
        }
    },
    filters: {
        subStr: function(string) {
            if(string.length > 47) {
                return string.substring(0, 43) + '...';
            }
            return string;
        }
    },
    watch:{
        edit(){
            this.hasChange = false
            if(this.chapter.isNew() && !this.inSave && !this.edit){
                this.removeConfirm()
            }
        },
        change:{
            handler(){
                this.hasChange = true
            },
            deep: true,
        }
    },
    mounted(){
        this.hasChange = false
        this.focus()
        this.old = JSON.stringify(this.chapter.getDataReq())
    }
}
</script>